module.exports = "<div class=\"gw-alert\" ng-class=\"'gw-alert_type_' + (type || 'info')\">\n    <i class=\"gw-alert__icon\" ng-class=\"icon()\"></i>\n    <div class=\"gw-alert__content\" ng-transclude></div>\n    <button ng-if=\"closeable\" type=\"button\" class=\"gw-alert__close\" ng-click=\"close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/inputs/templates/alert.html
// module id = 761
// module chunks = 0